// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import 'zone.js/dist/zone-error'
export const environment = {

   production: true,
baseUrl: 'https://webapi.r1.rpost.net/',
ActAPIbaseUrl:'https://activitytrackerapi.r1.rpost.net/',
productLine: 'RMail',//use RMailPrime for prime
AccessbaseUrl:'https://rmailif.r1.rpost.net/',
AccessUrl:'AutolockAccessDecision',
apiKey: '2FuZ3VsaUByc4AzdC5jb20iLCJTZXNzaW9uSWQiOiJmMzc0MjVl',
WebAPIv2Url:'https://webapi5.r1.rpost.net/',
DiinkRefUrl:'https://redact.r1.rpost.net/diink/{shortURL}',
EdiinkRefUrl:'https://redact.r1.rpost.net/ediink/{shortURL}/{lang}',
ViewTextRefUrl:'https://redact.r1.rpost.net/ViewText/{shortURL}',
ProtectedRefUrl:'https://redact.r1.rpost.net/protectedtext/{shortURL}',
OpenDetectionUrl:'https://rwg.r1.rpost.net/oatv_v3/',
PreSetEncryptPwdKey: 'h0CN8pwVSO4qTQzrhrWHDwqix6LpH5ZSqLrZi1Zc868=',
PreSetEncryptPwdIVector: 'Rm4l56uzIz7sHluOp7FbDg=='
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.